export default __webpack_public_path__ + "static/autocapture-dark-b91a69f23b45ba434b4106c7bcf86fca.png";